<template>
  <div
    class="modal theme-modal fade show"
    style="display: block; padding-right: 15px;"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="border modal-content">
        <div class="top-0 z-1 position-absolute me-3 mt-3 end-0">
          <button
            class="d-flex flex-center transition-base btn-close btn btn-sm btn-circle"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleSensorClose"
          />
        </div>

        <div class="bg-body-tertiary py-3 ps-4 pe-6 rounded-top-3">
          <h4
            id="staticBackdropLabel"
            class="mb-1"
          >
            센서 선택
          </h4>
        </div>

        <div class="px-card pt-1 pb-card modal-body fs--1">
          <div class="mt-3 media">
            <div class="media-body">
              <div class="text-800 fs--1">
                <h6 class="me-2 mb-0 device-label">
                  추가할 센서를 선택해 주세요.
                </h6>
                <CommGrid
                  ref="sensorListGridRef"
                  :rows="sensorList"
                  :columns="columnDefs"
                  :is-check-box="true"
                  :set-grid-height="500"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleAdd"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />추가
          </a>
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleSensorClose"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />취소
          </a>
        </div>
      </div>
    </div>
  </div>

  <AlertModal ref="alertModalRef" />
</template>

<script setup lang="ts">

import type { ColumnDefinition, Device, Sensor} from '@/types/commontypes'
import { onMounted, ref} from 'vue';
import AlertModal from "@/components/AlertModal.vue";
import CommGrid from '../components/CommGrid.vue'

const emit = defineEmits(['SensorListClose', 'SensorListAdd'])

const columnDefs = ref<ColumnDefinition[]>([]);
const sensorList = ref<Sensor[]>([])

const sensorListGridRef = ref();
const checkedSensorRows = ref<any[]>([]);

const alertModalRef = ref();

const props = defineProps<{
    setdevice: Device;
}>();

onMounted(async () =>{
  setSVList();
});


async function setSVList() {
    const columnList = [
        { field: 'sindex', label: 'ID'},
        { field: 'sname', label: '센서명'},
        { field: 'protocol', label: 'protocol'},
        { field: 'unit', label: '단위'},
        { field: 'dpoint', label: '소수점'}
    ]

    columnDefs.value = [...columnList];

    // sdata define json read
    const response = await fetch("/sdatadefine.json");
    if (!response.ok) throw new Error("Failed to load JSON");
    const dataJSON = await response.json();
    // console.log("sdatadefine json", dataJSON.slist);

    const filterList = [5,6,12,19]
    for (const [_, sensor] of Object.entries(dataJSON.slist as Record<string, Sensor>)) {
      if(filterList.includes(sensor.sindex))
        sensorList.value.push(sensor)
    }
}

const handleSensorClose = () => {
    emit('SensorListClose')
}

const handleAdd = () => {
    checkedSensorRows.value = sensorListGridRef.value.selectedRows;
    if(!checkedSensorRows.value || checkedSensorRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "센서를 선택하세요.");
        return;
    }

    const setdevice = props.setdevice;
    const svList = JSON.parse(setdevice.svlist);
    for(const adds of checkedSensorRows.value) {
        svList.push(adds);
    }

    setdevice.svlist = JSON.stringify(svList);

    emit('SensorListAdd')
}

</script>

<style lang="">
    
</style>